/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2022-12-20 18:57:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-01-12 09:05:06
 * @FilePath: \qcloud-web-pc-4.0\src\components\page-header\logo\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import './index.scss'
import LogoImg from '@/assets/images/logo_header.svg'
import { useAppSelector } from '@/redux/hooks';
import { getDomainAfterForward ,handleLocHref} from "../../../utils/index.js";
import { Link } from 'react-router-dom'
const Logo = () => {
  const { language } = useAppSelector((state) => state.common);
  const isZh = language === 'zh';
//   /**
//  * @description: 检测当前环境类型
//  * @returns 'production' | 'test' | 'preproduction'
//  */
// const detectEnvironment = () => {
//   const hostname = window.location.hostname;
  
//   // 线上环境: xxx.originqc.com.cn
//   if (hostname.includes('.originqc.com.cn')) {
//     return 'production';
//   }
  
//   // 测试环境: dtxxx.originqc.com (以 dt 开头)
//   if (hostname.startsWith('dt') && hostname.includes('.originqc.com')) {
//     return 'test';
//   }
  
//   // 预上线环境: xxx.originqc.com (包含 auth.originqc.com)
//   if (hostname.includes('.originqc.com')) {
//     return 'preproduction';
//   }
  
//   // 默认测试环境
//   return 'test';
// };
//   // localtion 链接跳转 href
//  const handleLocHref = (href: string) => {
//    const env = detectEnvironment();
//   if (env === 'production') {
//     // 正式环境: xxx.originqc.com.cn
//     return `https://qcloud.originqc.com.cn/`;
//   } else if (env === 'preproduction') {
//     // 预上线环境: xxx.originqc.com
//    return `https://qcloud.originqc.com/`;
//   } else {
//     // 测试环境: dtxxx.originqc.com
//     return `http://dtqcloud.originqc.com/`;
//   }
// }
  const toHomeFunc = () => {
    const getUrl = getDomainAfterForward(window.location.href);
    const apiUrl = handleLocHref('');
    console.log(getUrl,apiUrl,'u')
    if(getUrl === 1) {
      window.location.href = `${apiUrl}${language}`;
    }else if(getUrl){
      window.location.href = `${getUrl}/${language}`;
    }
  }

  //   const toHomeFunc = () => {
  //   const getUrl = getDomainAfterForward(window.location.href);
  //   if(getUrl === 1) {
  //     window.location.href = `https://qcloud.originqc.com.cn/${language}`;
  //   }else if(getUrl){
  //     window.location.href = `${getUrl}/${language}`;
  //   }
  // }
  return (
    <p className='page-header-logo'
      onClick={()=>toHomeFunc()}
    >
      <img className='logo' src={LogoImg} alt="" />
      {/* <i className="divided-line"></i>
      <span className='company-name'>{isZh ? '量子云' : 'OriginQ Cloud'}</span> */}
    </p>
  )
}

export default Logo